<template>
  <div class="distribution">
    <div class="_p" v-if="$store.state.screenWidth > 960">
      <div class="_center">
        <div class="_header">
          <h5>项目分布</h5>
          <span>PROJECT DISTRIBUTION</span>
          <div class="_line"></div>
        </div>
        <div class="_btm">
          <div class="_left">
            <img src="https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/map_02.gif" alt="" />
            <div class="_zhejiang"></div>
          </div>
          <div class="_right">
            <div class="_total">
              <div class="_sum">项目总数: <span>80+</span></div>
            </div>
            <div class="_distribute">
              <div class="_left">
                <div>华东地区</div>
                <div>华中地区</div>
                <div>华南地区</div>
                <div>西南地区</div>
                <div>西北地区</div>
              </div>
              <div class="_right"></div>
            </div>
            <div class="_distribute_img"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="_m_center" v-else-if="$store.state.screenWidth <= 960">
      <div class="_header">
        <h5>项目分布</h5>
        <span>PROJECT DISTRIBUTION</span>
        <div class="_line"></div>
      </div>
      <div class="_btm">
        <div class="_left">
          <img src="https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/map_02.gif" alt="" />
          <div class="_zhejiang"></div>
        </div>
        <div class="_right">
          <div class="_number">
            <div class="_total">
              <div class="_sum">项目总数: <span>80+</span></div>
            </div>
            <div class="_distribute">
              <div class="_left">
                <div>华东地区</div>
                <div>华中地区</div>
                <div>华南地区</div>
                <div>西南地区</div>
                <div>西北地区</div>
              </div>
              <div class="_right"></div>
            </div>
          </div>
          <div class="_distribute_img"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      // gif: require('../../assets/images/map_02.gif')
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.distribution {
  position: relative;
  width: 100%;
  ._p {
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/project_bg.jpg") no-repeat;
    background-position: center;
    background-size: 100% 100%;
    // width: 19.2rem;
	  // height: 9.31rem;
    ._center {
      padding-bottom: .3rem;
      ._header {
        width: 100%;
        padding-top: 0.38rem;
        text-align: center;
        font-size: 0.3rem;
        letter-spacing: 0.02rem;
        color: #fff;
        span {
          font-size: 0.18rem;
          color: #73859e;
          letter-spacing: 0.01rem;
        }
        ._line {
          width: 5.17rem;
          height: 0.02rem;
          background-image: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/light.png");
          background-size: cover;
          background-position: center;
          margin: 0.26rem auto 0;
        }
      }
      ._btm {
        width: 100%;
        display: flex;
        margin-top: 0.36rem;
        > ._left {
          position: relative;
          width: 9.32rem;
          height: 7.36rem;
          // background: url("../../assets/images/map_01.png") no-repeat;
          background-size: cover;
          // background-color: #f0f;
          img {
            width: 100%;
            height: 100%;
          }
          ._zhejiang {
            position: absolute;
            top: 60%;
            right: 2%;
            width: 1.22rem;
            height: 0.58rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/zhejiang.png") no-repeat;
            background-size: contain;
            background-position: center;
          }
        }
        ._right {
          width: 4.76rem;
          margin-top: 0.3rem;
          ._total {
            width: 2.36rem;
            height: 0.3rem;
            line-height: 0.3rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/proTotal.png") no-repeat;
            background-position: center;
            background-size: contain;
            font-size: 0.16rem;
            color: #fff;
            padding-left: 0.13rem;
            margin-left: 0.75rem;
            span {
              font-size: 0.22rem;
              color: #ecc800;
              font-weight: bold;
            }
          }
          ._distribute {
            width: 100%;
            height: 2.34rem;
            margin-top: 0.4rem;
            display: flex;
            // justify-content: space-between;
            ._left {
              // width: 0.65rem;
              flex: 1;
              font-size: 0.16rem;
              color: #fff;
              line-height: 0.5rem;
              margin-right: 0.08rem;
              text-align: right;
            }
            ._right {
              margin-top: 0.07rem;
              width: 2.92rem;
              // height: 234px;
              background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/distribute.png") no-repeat;
              background-position: center;
              background-size: contain;
            }
          }
          ._distribute_img {
            width: 4.47rem;
            height: 1.85rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/distribute_img.png") no-repeat;
            background-position: center;
            background-size: cover;
            margin-top: 0.76rem;
          }
        }
      }
    }
  }
  ._m_center {
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_01.png") no-repeat;
    background-position: center;
    background-size: cover;
    // height: 8.81rem;
    padding-bottom: 0.13rem;
    padding-left: 0.44rem;
    padding-right: 0.27rem;
    ._header {
      width: 100%;
      padding-top: 0.38rem;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
      ._line {
        width: 5.17rem;
        height: 0.02rem;
        background-image: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/light.png");
        background-size: cover;
        background-position: center;
        margin: 0.26rem auto 0;
      }
    }
    ._btm {
      width: 100%;
      ._left {
        text-align: center;
        margin-top: 0.1rem;
        img {
          width: 5.37rem;
          height: 4.24rem;
        }
        ._zhejiang {
          position: absolute;
          top: 3.76rem;
          right: 0.58rem;
          width: 1.22rem;
          height: 0.58rem;
          background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/zhejiang.png") no-repeat;
          background-size: contain;
          background-position: center;
        }
      }
      ._right {
        display: flex;
        ._number {
          width: 3.71rem;
          ._total {
            width: 2.36rem;
            height: 0.3rem;
            line-height: 0.3rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/proTotal.png") no-repeat;
            background-position: center;
            background-size: contain;
            font-size: 0.16rem;
            color: #fff;
            padding-left: 0.13rem;
            margin-left: 0.75rem;
            span {
              font-size: 0.22rem;
              color: #ecc800;
              font-weight: bold;
            }
          }
          ._distribute {
            width: 100%;
            height: 2.322rem;
            margin-top: 0.08rem;
            display: flex;
            ._left {
              flex: 1;
              font-size: 0.16rem;
              color: #fff;
              line-height: 0.45rem;
              margin-right: 0.08rem;
              text-align: right;
            }
            ._right {
              margin-top: 0.07rem;
              width: 2.52rem;
              // height: 234px;
              background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/distribute.png") no-repeat;
              background-position: center;
              background-size: contain;
            }
          }
        }
        ._distribute_img {
          width: 2.95rem;
          height: 3.24rem;
          background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_02.png") no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Distribution.vue